<template>
  <yxt-drawer
    :title="$t('pc_menu_type_2')"
    :visible="visible"
    @close="handleCancel"
    size="480px"
    direction="rtl"
  >
    <yxt-form
      class="form-wrapper"
      ref="formRef"
      :rules="rules"
      :model="formData"
      is-need-require
      is-need-tooltip
    >
      <yxt-form-item
        v-loading="loading"
        :label="$t('pc_select_role_label')"
        prop="auditRole"
      >
        <yxt-select
          :placeholder="$t('pc_select_placeholder')"
          value-key="id"
          prop-label="roleName"
          v-model="formData.auditRole"
          :disabled="!options.length"
        >
          <yxt-option
            v-for="item in options"
            :key="item.id"
            :label="item.roleName"
            :value="item"
          >
          </yxt-option>
        </yxt-select>
      </yxt-form-item>
      <!-- <div
        v-if="!options.length>0"
        class="color-gray-7 ta-c"
      >
        {{$t('pc_tip_no_audit_role')}}
      </div> -->
      <yxt-form-item
        class="sel-type-item"
        v-if="formData.auditRole && options.length>0"
        :label="$t('pc_audit_multi')"
      >
        <yxt-radio-group v-model="formData.auditType" class="role-radio">
          <yxt-radio :label="0">
            {{$t('pc_audit_or')}}
            <yxt-tooltip
              effect="dark"
              :content="$t('pc_audit_or_tip')"
            >
              <yxt-svg
                icon-class='question-cirlce-o'
                class="ml4 color-gray-7"
                width='16px'
                height='16px'
              ></yxt-svg>
            </yxt-tooltip>
          </yxt-radio>
          <yxt-radio :label="1">
            {{$t('pc_audit_and')}}
            <yxt-tooltip
              effect="dark"
              :content="$t('pc_audit_and_tip')"
            >
              <yxt-svg
                icon-class='question-cirlce-o'
                class="ml4 color-gray-7"
                width='16px'
                height='16px'
              ></yxt-svg>
            </yxt-tooltip>
          </yxt-radio>
        </yxt-radio-group>
      </yxt-form-item>

    </yxt-form>
    <div slot="footer">
      <yxt-button
        plain
        @click="handleCancel"
      >{{$t('pc_cancel_mini')}}</yxt-button>
      <yxt-button
        type='primary'
        :disabled="!formData.auditRole"
        @click="handleOk"
      >{{$t('pc_ok_mini')}}</yxt-button>
    </div>
  </yxt-drawer>
</template>
<script>
import { getAuditRoleByCode } from '../service';

export default {
  props: {
    default: Object,
    tmplCode: String
  },
  data() {
    return {
      loading: false,
      visible: true,
      limit: 10,
      dialogVisible: false,
      options: [],
      formData: {
        auditRole: '',
        auditType: 0
      },
      rules: {
        auditRole: [
          { required: true, message: this.$t('pc_select_role_tip'), trigger: 'blur' }]
      }
    };
  },
  watch: {
    default: {
      immediate: true,
      handler(v) {
        if (v) {
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          const {...others } = this.formData;
          if (v.roleList) {
            // hack ??格式未确定
            this.formData.auditRole = v.roleList[0];
          }
          for (const k in others) {
            if (typeof v[k] !== 'undefined') {
              this.formData[k] = v[k];
            }
          }
        }
      }
    }
  },
  mounted() {
    if (this.tmplCode) {
      this.initOptions();
    }
  },
  methods: {
    async initOptions() {
      try {
        this.loading = true;
        const list = await getAuditRoleByCode(this.tmplCode);
        this.options = list;
      } catch (e) {
        // error
        const msg = typeof e === 'string' ? e : e.message;
        this.$message.error(msg);
      } finally {
        this.loading = false;
      }
    },
    handleVisible(v) {
      this.$emit('update:visible', v);
    },
    handleCancel() {
      this.visible = false;
      this.handleVisible(false);
    },
    handleOk() {
      this.$refs.formRef.validate((isOk) => {
        if (isOk) {
          const { auditRole, ...others } = this.formData;
          others.roleList = [auditRole];
          this.$emit('click:ok', others);
        }
      });
    },
    closeSelect(done) {
      done(this.$refs.selector.showTip);
    }
  }
};
</script>
<style scoped lang="css">
.form-wrapper ::v-deep .yxt-select {
  width: 351px;
}

.sel-type-item ::v-deep .yxt-radio__label {
  display: inline-flex;
  align-items: center;
}
.form-wrapper ::v-deep .yxt-radio {
  line-height: 40px;
}
.wrapper {
  height: 100%;
}
.footer {
  position: absolute;
}
.ta-c {
  text-align: center;
}
</style>
